/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Image_Inspector_Copy_Snippet_AriaInputs */

const en_image_inspector_copy_snippet_aria = /** @type {(inputs: Image_Inspector_Copy_Snippet_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copy ${i?.label} snippet`)
};

const ar_image_inspector_copy_snippet_aria = /** @type {(inputs: Image_Inspector_Copy_Snippet_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`نسخ مقتطف ${i?.label}`)
};

const bn_image_inspector_copy_snippet_aria = /** @type {(inputs: Image_Inspector_Copy_Snippet_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} স্নিপেট কপি করুন`)
};

const de_image_inspector_copy_snippet_aria = /** @type {(inputs: Image_Inspector_Copy_Snippet_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}-Snippet kopieren`)
};

const es_image_inspector_copy_snippet_aria = /** @type {(inputs: Image_Inspector_Copy_Snippet_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copiar fragmento de ${i?.label}`)
};

const fr_image_inspector_copy_snippet_aria = /** @type {(inputs: Image_Inspector_Copy_Snippet_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copier l'extrait ${i?.label}`)
};

const pt_image_inspector_copy_snippet_aria = /** @type {(inputs: Image_Inspector_Copy_Snippet_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Copiar trecho de ${i?.label}`)
};

const zh_image_inspector_copy_snippet_aria = /** @type {(inputs: Image_Inspector_Copy_Snippet_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`复制 ${i?.label} 片段`)
};

const tr_image_inspector_copy_snippet_aria = /** @type {(inputs: Image_Inspector_Copy_Snippet_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} parçacığını kopyala`)
};

const ru_image_inspector_copy_snippet_aria = /** @type {(inputs: Image_Inspector_Copy_Snippet_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Копировать фрагмент ${i?.label}`)
};

const pl_image_inspector_copy_snippet_aria = /** @type {(inputs: Image_Inspector_Copy_Snippet_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kopiuj fragment ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Copy {label} snippet" |
*
* @param {Image_Inspector_Copy_Snippet_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_copy_snippet_aria = /** @type {((inputs: Image_Inspector_Copy_Snippet_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Copy_Snippet_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_copy_snippet_aria(inputs)
	if (locale === "bn") return bn_image_inspector_copy_snippet_aria(inputs)
	if (locale === "de") return de_image_inspector_copy_snippet_aria(inputs)
	if (locale === "es") return es_image_inspector_copy_snippet_aria(inputs)
	if (locale === "fr") return fr_image_inspector_copy_snippet_aria(inputs)
	if (locale === "pt") return pt_image_inspector_copy_snippet_aria(inputs)
	if (locale === "zh") return zh_image_inspector_copy_snippet_aria(inputs)
	if (locale === "tr") return tr_image_inspector_copy_snippet_aria(inputs)
	if (locale === "ru") return ru_image_inspector_copy_snippet_aria(inputs)
	if (locale === "pl") return pl_image_inspector_copy_snippet_aria(inputs)
	return en_image_inspector_copy_snippet_aria(inputs)
});